(() => {
  if (window.renaoThicknessGalleryReady) return;
  window.renaoThicknessGalleryReady = true;
  const targetAlt = 'Dikey akrilik blok kalınlık karşılaştırması';
  let lastActivation = 0;

  const findTargetMedia = (gallery) =>
    Array.from(gallery.querySelectorAll('[data-media-id]')).find((item) => {
      const image = item.querySelector('img');
      return image?.alt?.includes(targetAlt);
    });

  const showSelectionNote = (gallery, value) => {
    let note = gallery.querySelector('.renao-thickness-gallery-note');
    if (!note) {
      note = document.createElement('div');
      note.className = 'renao-thickness-gallery-note';
      note.setAttribute('role', 'status');
      note.setAttribute('aria-live', 'polite');
      note.innerHTML = `
        <span class="renao-thickness-gallery-note__depth"></span>
        <span class="renao-thickness-gallery-note__copy">Kalınlık karşılaştırması</span>
      `;
      gallery.appendChild(note);
    }

    const depth = value.includes('3 cm') ? '3 CM' : '2 CM';
    note.querySelector('.renao-thickness-gallery-note__depth').textContent = depth;
    note.classList.remove('is-visible');
    window.requestAnimationFrame(() => note.classList.add('is-visible'));

    window.clearTimeout(gallery.renaoThicknessNoteTimer);
    gallery.renaoThicknessNoteTimer = window.setTimeout(() => note.classList.remove('is-visible'), 2600);
  };

  const revealActiveMedia = (gallery, value) => {
    gallery.classList.add('renao-thickness-gallery-focus');
    gallery.classList.remove('renao-thickness-gallery-reveal');
    void gallery.offsetWidth;
    gallery.classList.add('renao-thickness-gallery-reveal');
    window.setTimeout(() => gallery.classList.remove('renao-thickness-gallery-reveal'), 700);
    showSelectionNote(gallery, value);
  };

  const activateWithoutPageScroll = (gallery, targetMedia, alignSlider = false) => {
    gallery.querySelectorAll('.product__media-item[data-media-id]').forEach((item) => {
      item.classList.toggle('is-active', item === targetMedia);
    });

    const thumbnail = gallery.querySelector(`[data-target="${targetMedia.dataset.mediaId}"]`);
    if (thumbnail && typeof gallery.setActiveThumbnail === 'function') gallery.setActiveThumbnail(thumbnail);

    if (alignSlider) {
      window.requestAnimationFrame(() => {
        targetMedia.parentElement?.scrollTo({ left: targetMedia.offsetLeft, behavior: 'auto' });
      });
    }
  };

  const deferWhilePreviewIsOpen = (gallery, targetMedia, mediaWrapper, value) => {
    activateWithoutPageScroll(gallery, targetMedia);
    gallery.dataset.renaoPendingThicknessValue = value;

    if (mediaWrapper.dataset.renaoThicknessObserverReady === 'true') return;
    mediaWrapper.dataset.renaoThicknessObserverReady = 'true';
    new MutationObserver(() => {
      if (mediaWrapper.classList.contains('has-renao-live-preview')) return;
      const pendingValue = gallery.dataset.renaoPendingThicknessValue;
      if (!pendingValue) return;
      const pendingMedia = findTargetMedia(gallery);
      if (pendingMedia) activateWithoutPageScroll(gallery, pendingMedia, true);
      delete gallery.dataset.renaoPendingThicknessValue;
      revealActiveMedia(gallery, pendingValue);
    }).observe(mediaWrapper, { attributes: true, attributeFilter: ['class'] });
  };

  const activateThicknessMedia = (input) => {
    const productInfo = input.closest('product-info');
    const gallery = productInfo?.querySelector('media-gallery');
    const targetMedia = gallery && findTargetMedia(gallery);
    if (!gallery || !targetMedia?.dataset.mediaId || typeof gallery.setActiveMedia !== 'function') return;

    const mediaWrapper = gallery.closest('.product__media-wrapper');
    const revealImmediately = Boolean(productInfo.querySelector('[data-renao-source-product-handle="arkadas2"], [data-renao-source-product-handle="arkadas3"], [data-renao-source-product-handle="suc"], [data-renao-source-product-handle="ark2"]'))
      || ["derin-sarkimiz", "derin-sarkimiz-kolaj", "derin-kolaj", "derin-ilk-anim", "ark3", "ark2", "suc", "babpremium", "babapremiumy", "babapremium6", "babapremium2", "kolajpremium", "babapremium", "annem-hep-benimlesin", "annelergunu2", "anneler-gunu", "premium-yatay-3", "birlikte-biriktirdiklerimiz-6-li-kolaj", "deneme", "spopr2", "klpk", "kpr", "bnetf", "iyiki", "bnetflix", "bmap"].includes(productInfo.dataset.url?.split('/').pop());
    if (revealImmediately && mediaWrapper?.classList.contains('has-renao-live-preview')) {
      mediaWrapper.querySelector('[data-renao-collage-show-product-media], [data-renao-show-product-media], [data-renao-music-show-product-media], [data-renao-netflix-show-product-media], [data-renao-iyiki-show-product-media], [data-renao-heart-photo-show-product-media]')?.click();
    }
    if (mediaWrapper?.classList.contains('has-renao-live-preview')) {
      deferWhilePreviewIsOpen(gallery, targetMedia, mediaWrapper, input.value);
      return;
    }

    gallery.setActiveMedia(targetMedia.dataset.mediaId, false);
    revealActiveMedia(gallery, input.value);
    if (revealImmediately) {
      // Variant updates restore focus asynchronously; scroll after that update.
      window.clearTimeout(gallery.renaoThicknessScrollTimer);
      gallery.renaoThicknessScrollTimer = window.setTimeout(() => {
        if (!gallery.isConnected) return;
        activateWithoutPageScroll(gallery, targetMedia, true);
        const top = targetMedia.getBoundingClientRect().top + window.scrollY - 24;
        window.scrollTo({ top: Math.max(0, top), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, 450);
    }
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const productInfo = document.querySelector(`product-info[data-section="${data?.sectionId}"]`);
      if (!productInfo?.querySelector('.renao-baby-thickness')) return;
      const form = productInfo.querySelector('product-form form');
      if (!form?.dataset.renaoEditKey) return;
      const url = new URL(window.location.href);
      url.searchParams.set('renao_edit', form.dataset.renaoEditKey);
      window.history.replaceState({}, '', url);
      if (data.variant?.available) {
        const label = form.querySelector('[type="submit"] span');
        if (label) label.textContent = 'Düzenlemeyi Bitir';
      }
    });
  }

  document.addEventListener('click', (event) => {
    const label = event.target.closest('label.renao-baby-thickness__option');
    if (!label) return;
    const input = document.getElementById(label.htmlFor);
    if (!input) return;
    lastActivation = performance.now();
    activateThicknessMedia(input);
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('.renao-baby-thickness input[type="radio"]');
    if (!input || performance.now() - lastActivation < 250) return;
    activateThicknessMedia(input);
  });
})();
